import React from 'react';
// import PropTypes from 'prop-types';
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {useStyles } from './../Complements/usesStyles'
import clsx from "clsx";
import { isMobile } from 'react-device-detect';


const MainMultiple = props => {
    const {  body, info, chart } = props
    const classes = useStyles(props);
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    return (
        <main className={classes.fondo}>
        <Container maxWidth="lg" className={classes.fondo}>
          {
            !isMobile ?
              <Grid container spacing={3}>
                {/* Recent Deposits */}
                <Grid item xs={12} md={4} lg={4}>
                    <Paper className={fixedHeightPaper}> { info } </Paper>
                </Grid>
                {/* Chart */}
                <Grid item xs={12} md={8} lg={8}>
                  <Paper className={fixedHeightPaper}>
                    { chart }
                </Paper>
                </Grid>
                {/* Recent Orders */}
                <Grid item xs={12}>
                  <Paper className={classes.paper}>
                    { body }
                  </Paper>
                </Grid>
              </Grid> :
              <Grid container spacing={3}>
              {/* Chart */}
              <Grid item xs={12} md={8} lg={8}>
                <Paper className={fixedHeightPaper}>
                  { chart }
              </Paper>
              </Grid>
              {/* Recent Deposits */}
              <Grid item xs={12} md={4} lg={4}>
                  <Paper >{ info }</Paper>
              </Grid>
              {/* Recent Orders */}
              <Grid item xs={12}>
                <Paper className={classes.paper}>
                  { body }
                </Paper>
              </Grid>
            </Grid>
          }
            
        </Container>
      </main>
    );
};

/* MainMultiple.propTypes = {
    
}; */

export default MainMultiple;